import React from "react";
import "./wallet.scss";
import Header from "../landing/Header/Header";

const WalletNotFound = () => {
  return (
    <>
      <Header />
      <section className="wallet-not-found">
        <div className="custom-container">
          <div className="parent">
            <img
              src="\assets\walleterror.svg"
              alt="img"
              className="img-fluid"
            />
            <h5>Wallet Not Found</h5>
            <p>
              We are unable to verify your wallet address. Please ensure you
              have connected the wallet used to purchase LEIA during the private
              sale.
              <br />
              <br />
              For further assistance, please contact our support team at:{" "}
              <a href="mailto: support@gems.vip">support@gems.vip</a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default WalletNotFound;
